import {
  dimensiondata_1_termekek_group_first_row_expanded,
  dimensiondata_2_tetelek_group_dimension_1_2_3_column,
  dimensiondata_2_tetelek_group_column,
  TJ_value_1_data_precision,
  year_column_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const evesHoTermelesConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EvesHoTermeles',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_termekek_group_first_row_expanded,
      year_column_expanded,
      ...dimensiondata_2_tetelek_group_dimension_1_2_3_column,
      TJ_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
